(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  function positionPromoTiles() {
    document.querySelectorAll('.product-grid').forEach((grid) => {
      const promoTiles = Array.from(grid.querySelectorAll(':scope > [data-promo-position]'));
      if (promoTiles.length === 0) return;

      const productTiles = Array.from(grid.children).filter((child) => !promoTiles.includes(child));

      promoTiles
        .map((el) => ({ el, position: parseInt(el.dataset.promoPosition, 10) || 0 }))
        .sort((a, b) => a.position - b.position)
        .forEach(({ el, position }) => {
          const referenceNode = productTiles[Math.min(position, productTiles.length)] || null;
          grid.insertBefore(el, referenceNode);
        });
    });
  }

  document.addEventListener('DOMContentLoaded', positionPromoTiles, { once: true });
  document.addEventListener('shopify:section:load', positionPromoTiles);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stln-editorial-collection"] && !Shopify.designMode) return;
  try {
    
  const stlnEditorialUrl = new URL(window.location.href);
  if (stlnEditorialUrl.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(stlnEditorialUrl.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
